import { render, staticRenderFns } from "./FormAppeal.vue?vue&type=template&id=057aea2c&"
import script from "./FormAppeal.vue?vue&type=script&lang=js&"
export * from "./FormAppeal.vue?vue&type=script&lang=js&"
import style0 from "./FormAppeal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports